export class ContactDTO {
  reason: string;
  description: string;
  subscriptionNumber: string;
  claimNumber: string;
  clientNumber: string;
  mobileChannel: boolean;

  constructor(reason?, clientNumber?, subscriptionNumber?,mobileChannel?) {
    this.reason = reason || '';
    this.mobileChannel = mobileChannel || '';
    this.description = '';
    this.clientNumber = clientNumber || '';
    this.subscriptionNumber = subscriptionNumber || '';
    this.claimNumber = null;
  }
}
